export default __webpack_public_path__ + "/dist/images/image9.1b5435db6543d5654c42992e02e362be.png";